import React from 'react'
import Radium from 'radium'

import Width from '../Width'
import Nav from './Nav/index'
import Content from './Content/index'
import colors from '../../theme/colors'
import borderRadius from '../../theme/borderRadius'
import boxShadow from '../../theme/boxShadow'

export default Radium((props) => (
  <Width>
    {({ isMedium, isSmall }) => (
      <div
        style={[
          styles.container,
          isMedium && styles.medium.container,
          isSmall && styles.small.container,
        ]}
      >
        <Nav />
        <Content {...props} />
      </div>
    )}
  </Width>
))

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    maxWidth: '768px',
    minHeight: '350px',
    backgroundColor: colors.white,
    padding: '50px 0',
    border: `1px solid ${colors.greyish}`,
    borderRadius,
    boxShadow,
  },
  medium: {
    container: {
      minHeight: 'initial',
      padding: '30px 0',
    },
  },
  small: {
    container: {
      flexDirection: 'column',
      padding: '0 0 30px',
    },
  },
}
